/**
 * Calculates the total protein content based on provided ingredients.
 */
export function calculateTotalProtein(ingredients: Ingredients): number | null {
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalProtein = [...ingredients].reduce(addProtein, 0);

  return Math.round(totalProtein);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.proteinG !== 'number';
}

function addProtein(total: number, ingredient: Ingredient) {
  const protein = typeof ingredient.proteinG === 'number' ? ingredient.proteinG : 0; // prettier-ignore
  const quantity = ingredient.quantity ?? 1;

  return total + protein * quantity;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Ingredient = { proteinG: number | null; quantity?: number };
type Ingredients = Ingredient[] | readonly Ingredient[];
